export default __webpack_public_path__ + "static/media/View locks off.0f7a1fa6.svg";